import React, { useRef, useState } from "react";
import styles from "../../../Pages/Users/Users/users.module.css";
import { TfiMenuAlt } from "react-icons/tfi";
import { PiSquaresFour } from "react-icons/pi";
import { CiSearch } from "react-icons/ci";
import WeekRangeDropdown from "../../Dropdown/WeekRange";
import CalendarComp from "../../CalendarComp/CalendarComp";
import SelectDropdown from "../../Dropdown/SelectDropdown";
import { VscCloudDownload } from "react-icons/vsc";
import * as XLSX from "xlsx";
import { RegionMasterApi } from "../../../App/api/RegionMaster";
import { toast } from "react-toastify";

const FiltersComp = ({
  gridToggle,
  SetGridToggle,
  layoutView,
  SearchBy,
  handleSearch,
  handleFilter,
  handleClearFilter,
  filters,
  WeekRange,
  MonthRange,
  canlenderFilter,
  actionButton,
  isImport,
}) => {
  const [clear, setClear] = useState(false);
  const search = useRef();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async (event) => {
      const wb = XLSX.read(event.target.result, { type: "binary" });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(sheet);

      try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await RegionMasterApi.importDeliveryRegion(formData);
        toast.success("Data imported successfully!!");

        if (response.success) {
        } else {
          console.error("Error in backend response", response.message);
        }
      } catch (error) {
        console.error("Error during file upload or API call", error);
      }
    };

    reader?.readAsBinaryString?.(file);
  };

  const downloadTemplate = () => {
    const headers = [
      [
        "regionType",
        "country",
        "cityData",
        "zoneCode",
        "additionalFee",
        "referralFeeRate",
        "closingFeeRate",
        "shippingFeeRate",
        "shippingHandlingFeeFixedRate",
      ],
    ];

    const ws = XLSX.utils.aoa_to_sheet(headers);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");

    XLSX.writeFile(wb, "template.csv", { bookType: "csv" });
  };

  return (
    <>
      <div className={styles.subcontainer1}>
        {layoutView ? (
          <>
            <div
              onClick={() => SetGridToggle(false)}
              style={{ cursor: "pointer" }}
            >
              <TfiMenuAlt
                size={"1.3rem"}
                color={gridToggle ? "black" : "var(--color--1)"}
              />
            </div>
            <div
              onClick={() => SetGridToggle(true)}
              style={{ cursor: "pointer" }}
            >
              <PiSquaresFour
                size={"1.9rem"}
                color={!gridToggle ? "black" : "var(--color--1)"}
              />
            </div>
          </>
        ) : null}
        {SearchBy.options.length ? (
          <SelectDropdown
            inputName={SearchBy.inputName}
            placeholder={SearchBy.filterType}
            options={SearchBy.options}
            handleFilter={handleFilter}
            setClear={setClear}
            clear={clear}
            sx={{
              border: "1px solid var(--color--11)",
              borderRadius: "20px",
              height: "2rem",
            }}
          />
        ) : null}
        {SearchBy.options.length ? (
          <div className={styles.border_search}>
            <input
              ref={search}
              // value={clear?"":}
              type="text"
              style={{
                border: "none",
                outline: "none",
                backgroundColor: "transparent",
              }}
              // className={styles.border_search}
              placeholder="Search"
              onChange={(e) => {
                // console.log("search",e.target.value);
                handleSearch && handleSearch(e.target.value);
              }}
            />
            <CiSearch size={"1.1rem"} />
          </div>
        ) : null}
        {filters &&
          filters.map((f, i) => (
            <SelectDropdown
              key={i}
              inputName={f.inputName}
              placeholder={f.filterType}
              options={f.options}
              handleFilter={handleFilter}
              setClear={setClear}
              clear={clear}
              sx={{
                border: "1px solid var(--color--11)",
                borderRadius: "20px",
                height: "2rem",
              }}
            />
          ))}
        {WeekRange ? <WeekRangeDropdown handleFilter={handleFilter} /> : ""}
        {MonthRange ? (
          <CalendarComp
            canlenderFilter={canlenderFilter}
            handleFilter={handleFilter}
            sxCal={{
              border: "1px solid var(--color--11)",
              borderRadius: "20px",
            }}
          />
        ) : (
          ""
        )}

        {SearchBy.options.length ? (
          <>
            <div>
              <button
                onClick={() => {
                  setClear(true);
                  search.current.value = "";
                  handleSearch && handleSearch("");
                  handleClearFilter && handleClearFilter();
                }}
                className={styles.border}
              >
                Clear Filter
              </button>
            </div>
          </>
        ) : null}

        {isImport && (
          <div className="flex gap-1">
            <button
              onClick={downloadTemplate}
              className="flex w-40 items-center gap-2 px-2 py-2 bg-[#028006] text-white font-semibold rounded-lg shadow-lg "
            >
              <span>Download Template</span>
              <i>
                <VscCloudDownload />
              </i>
            </button>

            <label
              htmlFor="file-upload"
              className="flex items-center gap-2 px-2 py-2 bg-[#028006] text-white font-semibold rounded-lg shadow-lg cursor-pointer"
            >
              <span>Import</span>
              <i>
                <VscCloudDownload />
              </i>
            </label>
            <input
              id="file-upload"
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
          </div>
        )}

        {actionButton && (
          <button
            className={styles.border_apply}
            onClick={actionButton.handleButton}
          >
            {actionButton?.button_name}
          </button>
        )}
      </div>
    </>
  );
};

export default FiltersComp;
